module.exports = __webpack_public_path__ + "static/media/inventory_2_black_24dp.edaf94df.svg";